// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__t7PF9","inputForm":"Auth_inputForm__9-bie","theButton":"Auth_theButton__e9E5a"};